// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"HomePage_sectionWrapper__lC5+i"};